import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ats-redirect',
  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectComponent implements OnInit {
  constructor(private router: Router) {}

  async ngOnInit(): Promise<void> {
    const url = this.router.url.replace(/^\/feedz/, '').replace(/^\/default/, '');
    await this.router.navigateByUrl(url, { replaceUrl: true });
  }
}
